<desy-card
  classes="w-1/3"
  [containerClasses]="'p-base border-2 lg:w-1/3 lg:min-w-96 border-neutral-400 shadow-md shadow-neutral-300 '">
  <div>
    <div class="flex items-center">
      <div
        class="h-4 w-4"
        [ngClass]="color"></div>
      <h3
        id="titulo-card-1"
        class="text-[18px] font-semibold ml-2">
        {{ title | uppercaseAll }}
      </h3>
    </div>
    <hr class="my-4" />
    <div class="flex items-center">
      <div class="text-5xl">{{ count }}</div>
      <div class="ml-4">
        <div class="text-[16px]">{{ description }}</div>
        <a
          [routerLink]="url"
          [queryParams]="{ state }"
          class="text-primary-base font-semibold underline hover:no-underline"
          id="boton-card-1"
          aria-labelledby="boton-card-1 titulo-card-1">
          {{ textUrl }}
        </a>
      </div>
    </div>
  </div>
</desy-card>
